<template>
  <v-card class="pt-3 elevation-0">
    <v-card-title class="subtitle-1 primary--text font-weight-bold pb-0">
      <v-row>
        <v-col sm="11" class="pt-2 font-weight-black primary--text subtitle-1">Member Comments</v-col>

        <v-col v-if="editable" sm="1" class="text-sm-right">
          <v-btn
            icon
            @click="isAdditionalCommentsFormVisible = true"
            class="mt-n3"
            data-cy="additionalComments__button--editComments"
            data-test="edit-comments-btn"
          >
            <v-icon small>far fa-edit</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text v-if="!isAdditionalCommentsFormVisible">
      <div v-if="editable" class="och-field--inline-editable px-1" @click="isAdditionalCommentsFormVisible = true">
        <span v-html="testPlan.additionalComments || '<i>(No comments)</i>'"></span>
      </div>
      <div v-else class="och-field--inline-notEditable px-1">
        <span v-html="testPlan.additionalComments || '<i>(No comments)</i>'"></span>
      </div>
    </v-card-text>
    <v-card-text
      v-if="isAdditionalCommentsFormVisible"
      data-cy="releaseNoteForm__container--additionalComments"
      data-test="additional-comments-form"
    >
      <phi-warning class="mb-2 mt-n2"></phi-warning>
      <ckeditor
        :config="ckeditorConfig"
        @focus="setCurrentEditor($event)"
        v-model="testPlan.additionalComments"
        id="additionalComments"
      ></ckeditor>
      <v-card-actions class="mt-2">
        <v-btn
          @click="cancelAdditionalComments"
          data-cy="testPlanView__button--cancelAdditionalComments"
          data-test="cancel-additional-comments-btn"
          outlined
          >Cancel</v-btn
        >
        <v-btn
          @click="saveAdditionalComments"
          color="primary"
          data-cy="testPlanView__button--saveAdditionalComments"
          data-test="save-additional-comments-btn"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import Ckeditor from "vue-ckeditor2";

import PhiWarning from "@/components/PhiWarning";

export default {
  name: "testPlanComments",
  components: {
    Ckeditor,
    PhiWarning,
  },
  computed: {
    serviceArea() {
      return this.$store.state.session.serviceArea;
    },
    testPlan() {
      return this.$store.state.releaseNote.testPlan;
    },
  },
  data() {
    return {
      ckeditorConfig: {
        startupFocus: true,
        toolbarGroups: [
          { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi", "paragraph"],
          },
          { name: "links", groups: ["links"] },
          { name: "insert", groups: ["insert"] },
          "/",
          { name: "styles", groups: ["styles"] },
          { name: "colors", groups: ["colors"] },
          { name: "tools", groups: ["tools"] },
          { name: "others", groups: ["others"] },
          { name: "about", groups: ["about"] },
          {
            name: "editing",
            groups: ["find", "selection", "editing"],
          },
          { name: "forms", groups: ["forms"] },
          { name: "document", groups: ["mode", "document", "doctools"] },
          { name: "clipboard", groups: ["clipboard", "undo"] },
        ],
        removeButtons:
          "Flash,Iframe,PageBreak,Language,About,Subscript,Superscript,CopyFormatting,Anchor,Find,Replace,SelectAll,Cut,Copy,PasteFromWord,Paste,Templates,Save,NewPage,Preview,Print,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField",
        height: 200,
        versionCheck: false,
      },
      isAdditionalCommentsFormVisible: false,
    };
  },
  methods: {
    async cancelAdditionalComments() {
      this.isAdditionalCommentsFormVisible = false;
      await this.$store.dispatch("releaseNote/getTestPlan", {
        releaseNoteId: this.releaseNoteId,
        serviceArea: this.serviceArea,
      });
    },
    async getAdditionalComments() {
      this.isAdditionalCommentsFormVisible = false;
      await this.$store.dispatch("releaseNote/getTestPlan", {
        releaseNoteId: this.releaseNoteId,
        serviceArea: this.serviceArea,
      });
    },
    async saveAdditionalComments() {
      this.setEditorContent();
      try {
        await this.$store.dispatch("releaseNote/updateTestPlan", this.testPlan);
      } catch (error) {
        console.error(error);
        this.$notifyError("Unable to save member comments");
      }
      this.isAdditionalCommentsFormVisible = false;
      await this.$store.dispatch("releaseNote/getTestPlan", {
        releaseNoteId: this.releaseNoteId,
        serviceArea: this.serviceArea,
      });
      await this.$store.dispatch("auditLog/fetchTestPlan", {
        releaseNoteId: this.releaseNoteId,
        serviceAreaId: this.serviceArea,
      });
    },
    setCurrentEditor({ editor }) {
      this.currentEditor = editor.name;
    },
    setEditorContent() {
      const editor = CKEDITOR.instances[this.currentEditor];
      const editableContent = editor.editable();
      if (editableContent.getData() !== this.testPlan[editor.name]) {
        this.testPlan[editor.name] = editableContent.getData();
      }
    },
  },
  props: {
    releaseNoteId: {
      type: [String, Number],
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    $route() {
      this.getAdditionalComments();
    },
  },
};
</script>
